<template>
    <form name='form' v-on:submit.prevent="sendForm(formdata)">
        <div class="row whole">
            <div class="col-60 col-lg-30">
                <label for="name">Name *</label>
                <input type="text" v-model="formdata.name" required id="name">
                <label for="firma">Firma</label>
                <input type="text" v-model="formdata.firma" id="firma">
                <label for="email">E-Mail-Adresse *</label>
                <input type="email" v-model="formdata.email" required id="email">
            </div>
            <div class="col-60 col-lg-30">
                <label for="message">Nachricht *</label>
                <textarea rows="5" id="message" v-model="formdata.message" required
                ></textarea>
                <textarea rows="5" v-model="formdata.hmessage" style="opacity: 0;height: 0;"
                          placeholder="Nachricht"></textarea>
                <input type="hidden" v-model="formdata.formtype">
                <br>
            </div>
        </div>
        <div class="line row">
            <div class="col-60 col-lg-30">
                <div style="display: flex">
                    <input type="checkbox" id='dsgvo' v-model="formdata.dsgvo"
                           style="min-width: 50px;width: 50px;height: 15px;" required>
                    <label for="dsgvo" style="margin-bottom: 0;font-size: 0.9em;line-height: 1.2em;">
                        <div>
                            * Zustimmung zur Datenspeicherung.
                            Dieses Formular speichert die angegebenen Daten sowie Ihre IP-Adresse zwecks
                            Kontaktaufnahme und Spamprüfung. Weitere Informationen finden Sie auf unserer Seite der
                            <a href="/datenschutz" target="_blank">Datenschutzbestimmungen</a>.
                        </div>
                    </label>

                </div>
                <br>
                <br>
            </div>
            <div class="col-60 col-lg-30">
                <div class="" v-if="!errorsent && !justsent">
                    <button class="submit d-flex" type="submit" id="submitbutton">
                        <svg width="24" height="13" viewBox="0 0 24 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.5 0.5L22.5 6.5M22.5 6.5L16.5 12.5M22.5 6.5H0" stroke="#AD6766"/>
                        </svg>
                        <div style="padding-left: 5px;">
                            &nbsp;&nbsp;Abschicken
                        </div>
                    </button>
                    <br>
                    <div style="color:#888;">
                        * - Pflichtfelder
                    </div>
                </div>
                <div id="error" class=" " v-if="errorsent">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" style="width: 100%;text-align: center">Sorry!</h5>
                            </div>
                            <div class="modal-body">
                                Die Nachricht konnte nicht gesendet werden.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="success" class="" v-if="justsent">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" style="width: 100%;text-align: center">Danke!</h5>
                        <!--<button type="button" class="close" data-dismiss="modal" aria-label="Close">-->
                        <!--<span aria-hidden="true">&times;</span>-->
                        <!--</button>-->
                    </div>
                    <div class="modal-body">
                        Vielen Dank! Wir haben Ihre Nachricht erhalten. In Ihrem Postfach finden Sie eine
                        Bestätigungsmail.
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>
<script>
    import jQuery from 'jquery'

    export default {
        name: "Formular",
        data() {
            return {
                formdata: {formtype: 'small'},
                justsent: false,
                errorsent: false
            }
        },
        methods: {
            sendForm: function (data) {
                let $submit = jQuery('#submitbutton');
                $submit.prop("disabled", true)
                setTimeout(function () {
                    $submit.prop("disabled", false)
                }, 2000)
                let strippeddata = JSON.parse(JSON.stringify(data))
                let url = process.env.NODE_ENV === 'development' ? 'https://zzagentur.de/mailanfrage' : '/mailanfrage'
                jQuery.ajax({
                    url: url,
                    type: 'post',
                    data: strippeddata,
                    error: function () {
                        this.errorsent = true
                    }.bind(this)
                })
                    .done(function (val) {
                        try {
                            if (JSON.parse(val).success) {
                            this.justsent = true;
                            }
                            else this.errorsent = true;
                        } catch (e) {
                            console.log(e)
                            this.errorsent = true
                        }
                    }.bind(this))
            },
        }
    }
</script>
<style scoped lang="scss">
    input {
        width: 100%;
        background: #fff;
        box-shadow: inset 0px 0px 0px 0px red;
        border-color: #fff;
        padding: 5px 10px;
        margin-bottom: 10px;
        color: $zzgray;
        border-style: none;

        outline: 1px solid #fff;
        @include mobile {
            outline-color: #eee;
        }
        &:focus {
            outline-color: #ccc;
        }
    }

    textarea {
        border-color: #fff;
        width: 100%;
        padding: 10px;
        color: $zzgray;


        outline: 1px solid #fff;
        @include mobile {
            outline-color: #eee;
        }
        &:focus {
            outline-color: #ccc;
        }
    }

    label {
        //styleName: <p> - copy BIG;
        font-family: $sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 300;
        line-height: 29px;
        letter-spacing: 0.02em;
        text-align: left;
        margin-bottom: 0;
        color: #888;
    }

    #submitbutton {

        font-size: 18px;
        line-height: 120%;
        /* or 14px */
        border: 1px solid #AD6766;
        box-sizing: border-box;
        border-radius: 100px;
        display: flex;
        align-items: center;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        padding: 5px 10px;
        /* ZZ - Rostrot - heller */
        color: #AD6766;
        background-color: transparent;
        &:focus, &:hover{
            background-color: #ad6766;
            color: #fff;
            svg path{
                stroke: #fff;
            }
        }
    }
</style>